import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import gsap from 'gsap';

/**
 * LoadingSpinner Component
 *
 * Full-page loading spinner with dark arcade theme and GSAP animations.
 * Used as Suspense fallback for initial app load.
 */
export function LoadingSpinner() {
  const { t } = useTranslation('common');
  const containerRef = useRef<HTMLDivElement>(null);
  const dotsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      if (dotsRef.current) {
        const dots = dotsRef.current.children;
        gsap.to(dots, {
          y: -12,
          duration: 0.4,
          ease: 'power2.out',
          stagger: { each: 0.15, repeat: -1, yoyo: true },
        });
      }
    }, containerRef);

    return () => ctx.revert();
  }, []);

  return (
    <div
      ref={containerRef}
      className="flex flex-col items-center justify-center min-h-screen gap-4"
      style={{ background: '#0D0D1A' }}
    >
      <div ref={dotsRef} className="flex gap-3">
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            className="w-3 h-3 rounded-full"
            style={{ background: '#F4D35E' }}
          />
        ))}
      </div>
      <p className="text-sm" style={{ color: 'rgba(255,255,255,0.5)' }}>
        {t('loading')}
      </p>
    </div>
  );
}

export default LoadingSpinner;
